import { Controller, useFormContext } from 'react-hook-form';
import { createUseStyles } from 'src/theming';
import { Grid, InputAdornment, TextField, Typography } from '@material-ui/core';
import React from 'react';
import InstallationTestField from './components/InstallationTestField';
import { PostInterventionOrderBody } from 'src/interfaces/api/InterventionOrder';

const useStyles = createUseStyles({
  section: {},
  sectionTitle: {
    fontWeight: 'bold !important',
  },
});

const InstallationSection = () => {
  const classes = useStyles();

  const { control } = useFormContext<PostInterventionOrderBody>();

  return (
    <Grid container spacing={2}>
      <Grid className={classes.section} item xs={12} sm={2}>
        <Typography variant='overline' className={classes.sectionTitle}>
          Débits
        </Typography>
      </Grid>

      <Grid item xs={12} sm={5}>
        <Controller
          name='upstreamRate'
          control={control}
          rules={{ required: { value: true, message: 'Le champ est requis' } }}
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              label='Débit montant'
              variant='outlined'
              type='number'
              InputProps={{
                endAdornment: <InputAdornment position='end'>Mbps</InputAdornment>,
              }}
              fullWidth
              error={undefined !== error}
              helperText={error?.message}
            />
          )}
        />
      </Grid>

      <Grid item xs={12} sm={5}>
        <Controller
          name='downstreamRate'
          control={control}
          rules={{ required: { value: true, message: 'Le champ est requis' } }}
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              label='Débit descendant'
              variant='outlined'
              type='number'
              fullWidth
              InputProps={{
                endAdornment: <InputAdornment position='end'>Mbps</InputAdornment>,
              }}
              error={undefined !== error}
              helperText={error?.message}
            />
          )}
        />
      </Grid>

      <Grid className={classes.section} item xs={12} md={2}>
        <Typography variant='overline' className={classes.sectionTitle}>
          Tests d'appel
        </Typography>
      </Grid>

      <Grid item xs={12} sm={5} style={{ display: 'flex', alignItems: 'center' }}>
        <Controller
          name='callTest'
          control={control}
          rules={{ required: { value: true, message: 'Le champ est requis' } }}
          render={({ field, fieldState: { error } }) => (
            <InstallationTestField
              {...field}
              error={undefined !== error}
              helperText={error?.message}
              label='112, 18, 17, 15, 3969'
            />
          )}
        />
      </Grid>

      <Grid item xs={12} sm={5} style={{ display: 'flex', alignItems: 'center' }}>
        <Controller
          name='callLocationTest'
          control={control}
          rules={{ required: { value: true, message: 'Le champ est requis' } }}
          render={({ field, fieldState: { error } }) => (
            <InstallationTestField
              {...field}
              error={undefined !== error}
              helperText={error?.message}
              label="Localisation de l'appel"
            />
          )}
        />
      </Grid>

      <Grid className={classes.section} item xs={12} md={2}>
        <Typography variant='overline' className={classes.sectionTitle}>
          Tests divers
        </Typography>
      </Grid>

      <Grid item xs={12} md={10}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} style={{ display: 'flex', alignItems: 'center' }}>
            <Controller
              name='scannerTest'
              control={control}
              rules={{ required: { value: true, message: 'Le champ est requis' } }}
              render={({ field, fieldState: { error } }) => (
                <InstallationTestField
                  {...field}
                  error={undefined !== error}
                  helperText={error?.message}
                  label='Scanner'
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={6} style={{ display: 'flex', alignItems: 'center' }}>
            <Controller
              name='printerTest'
              control={control}
              rules={{ required: { value: true, message: 'Le champ est requis' } }}
              render={({ field, fieldState: { error } }) => (
                <InstallationTestField
                  {...field}
                  error={undefined !== error}
                  helperText={error?.message}
                  label='Imprimante'
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={6} style={{ display: 'flex', alignItems: 'center' }}>
            <Controller
              name='faxTest'
              control={control}
              rules={{ required: { value: true, message: 'Le champ est requis' } }}
              render={({ field, fieldState: { error } }) => (
                <InstallationTestField {...field} error={undefined !== error} helperText={error?.message} label='Fax' />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={6} style={{ display: 'flex', alignItems: 'center' }}>
            <Controller
              name='tpeTest'
              control={control}
              rules={{ required: { value: true, message: 'Le champ est requis' } }}
              render={({ field, fieldState: { error } }) => (
                <InstallationTestField {...field} error={undefined !== error} helperText={error?.message} label='TPE' />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={6} style={{ display: 'flex', alignItems: 'center' }}>
            <Controller
              name='portabilityTest'
              control={control}
              rules={{ required: { value: true, message: 'Le champ est requis' } }}
              render={({ field, fieldState: { error } }) => (
                <InstallationTestField
                  {...field}
                  error={undefined !== error}
                  helperText={error?.message}
                  label='Portabilité'
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={6} style={{ display: 'flex', alignItems: 'center' }}>
            <Controller
              name='alarmTest'
              control={control}
              rules={{ required: { value: true, message: 'Le champ est requis' } }}
              render={({ field, fieldState: { error } }) => (
                <InstallationTestField
                  {...field}
                  error={undefined !== error}
                  helperText={error?.message}
                  label='Alarme'
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={6} style={{ display: 'flex', alignItems: 'center' }}>
            <Controller
              name='frankingMachineTest'
              control={control}
              rules={{ required: { value: true, message: 'Le champ est requis' } }}
              render={({ field, fieldState: { error } }) => (
                <InstallationTestField
                  {...field}
                  error={undefined !== error}
                  helperText={error?.message}
                  label='Machine à affranchir'
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={6} style={{ display: 'flex', alignItems: 'center' }}>
            <Controller
              name='mailTest'
              control={control}
              rules={{ required: { value: true, message: 'Le champ est requis' } }}
              render={({ field, fieldState: { error } }) => (
                <InstallationTestField
                  {...field}
                  error={undefined !== error}
                  helperText={error?.message}
                  label='Mail entrant/sortant'
                />
              )}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default InstallationSection;
